import { ServiceWorkerAction } from './constants';

export const sleep = (ms: number): Promise<void> => new Promise((res) => setTimeout(res, ms));

export const triggerWorkerAction = <T>(action: ServiceWorkerAction, data: T): void => {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.controller?.postMessage({
      type: action,
      payload: data,
    });
  } else {
    throw new Error('Service Worker is not supported in this browser.');
  }
};

export const executeApiRequest = (
  path: string,
  headers: { [key: string]: string },
  body: any,
  signal?: AbortSignal
) => {
  return fetch(path, {
    method: 'POST',
    headers: {
      ...headers,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
    signal,
  });
};
